import React, { useState } from "react";
import { SingleAddon } from "..";
import "./style.scss";
import { ReactComponent as IconSvg } from "../ListinExperienceAssets/info.svg";
import Modal from "components/LoginAndRegister/Modal";
import ListingExperienceDetails from "../ListingExperienceDetails";
import { useTheme } from "components/ListingNew/ListingTheme";
import clevertap from "clevertap-web-sdk";
const ListingExperienceCard = ({
	singleAddon,
	allAddons,
	index,
	listingId,
}: {
	singleAddon: SingleAddon;
	allAddons: SingleAddon[];
	index: number;
	listingId: string;
}) => {
	const [isOpenDetails, setIsOpenDetails] = useState(false);

	const theme = useTheme();
	const addonTypes = [
		{
			type: "PP",
			label: "Per Person",
		},
		{
			type: "PPPN",
			label: "Per Person Per Night",
		},
		{
			type: "OT",
			label: "One Time",
		},
		{
			type: "PN",
			label: "Per Night",
		},
	];
	
	return (
		<>
			<div
				onClick={(e) => {
					e.stopPropagation();
					setIsOpenDetails(true);
				}}
				className="listing-experience-card-wrapper"
			>
				<div className="listing-experience-card-content">
					<div className="listing-experience-card-img">
						<img
							loading="lazy"
							src={
								"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-50,w-600,h-auto,f-webp/" +
								singleAddon?.IMAGE_URL
							}
							alt={singleAddon?.ADD_ON_NAME}
						/>
					</div>

						<div className="listing-experience-card-footer">
							<h3>{singleAddon?.ADD_ON_NAME}</h3>
							{theme?.name === "xseries" ? null : (
							<div className="listing-experience-card-sub-footer">
								{
									singleAddon?.PRICE !==0 &&
								<div className="listing-experience-card-subfooter-texts">
									{singleAddon?.PAYMENT_TYPE !== "Prepaid Online" && (
										<p className="starting">Starting</p>
									)}
									<p className="price">
										₹ {singleAddon.PRICE} /{" "}
										<strong>
											{
												addonTypes.find(
													(addonType) => addonType.type === singleAddon?.TYPE,
												)?.label
											}
										</strong>
									</p>
								</div>
								}
								<button
									onClick={(e) => {
										clevertap.event.push("listing-experience-details", {
											LISTING_ID: listingId,
											NAME: singleAddon?.ADD_ON_NAME,
											MAP_ID: singleAddon?.MAP_ID,
										});
									}}
								>
									<IconSvg />
								</button>
							</div>
							)}
						</div>

				</div>
			</div>
			<Modal
				shouldShow={isOpenDetails}
				onRequestClose={() => {
					setIsOpenDetails(false);
				}}
			>
				<ListingExperienceDetails allAddons={allAddons} id={index} />
			</Modal>
		</>
	);
};

export default ListingExperienceCard;
